//const host = 'http://64.227.65.121'
//const host = 'http://localhost'

//const host = 'http://localhost:8000'
const host = 'https://hostel.kafu.kz'

export default host